
namespace TabAurous.Production {

    @Serenity.Decorators.registerClass()
    export class TreeMakingReceiptDialog extends Serenity.EntityDialog<TreeMakingReceiptRow, any> {
        protected getFormKey() { return TreeMakingReceiptForm.formKey; }
        protected getIdProperty() { return TreeMakingReceiptRow.idProperty; }
        protected getLocalTextPrefix() { return TreeMakingReceiptRow.localTextPrefix; }
        protected getNameProperty() { return TreeMakingReceiptRow.nameProperty; }
        protected getService() { return TreeMakingReceiptService.baseUrl; }
        protected getDeletePermission() { return TreeMakingReceiptRow.deletePermission; }
        protected getInsertPermission() { return TreeMakingReceiptRow.insertPermission; }
        protected getUpdatePermission() { return TreeMakingReceiptRow.updatePermission; }

        protected form = new TreeMakingReceiptForm(this.idPrefix);
        constructor() {
            super();
            q.HideCategoryLable(this.element);
        }
        protected onDialogOpen() {
            super.onDialogOpen();
            var x = this.form.SubCategoryId.value;
            var y = this.form.CategoryId.value;
            
        }
    }
}